<script setup lang="ts">
import TabVersion from "@/components/tabs/common/version.vue";

import type { VersionOwnerType } from "@/common/types/common/version";

defineProps<{
  ownerType: VersionOwnerType;
  ownerId: string;
}>();
</script>

<template>
  <div class="tab-versions">
    <tab-version
      :owner-type="ownerType"
      :owner-id="ownerId"
      relation-type="this_console"
    />
    <tab-version
      :owner-type="ownerType"
      :owner-id="ownerId"
      relation-type="other_systems"
    />
    <tab-version
      :owner-type="ownerType"
      :owner-id="ownerId"
      relation-type="compilation"
    />
    <tab-version
      :owner-type="ownerType"
      :owner-id="ownerId"
      relation-type="console_memory"
    />
    <tab-version
      :owner-type="ownerType"
      :owner-id="ownerId"
      relation-type="unofficial_other_systems"
    />
  </div>
</template>

<style lang="scss" scoped>
.tab-versions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
